// The pieces every variant shares, in the theme's colours (the site's and the admin's):
// the arrows beside the button, the Range | Week | Month | Quarter | Year tabs
// and the panels behind them.
export const PERIOD = {
  stepper: "flex items-center gap-1",
  step_button: "shrink-0 p-1 rounded-md text-primary hover:bg-primary/10 disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-default",
  step_icon: "w-5 h-5",
  popup_wide: "w-[330px] max-w-[calc(100vw-32px)]",
  tabs: "flex mb-3 rounded-lg border border-bordered overflow-hidden",
  tab: {
    base: "flex-1 px-1 py-1.5 text-sm text-center border-r border-bordered last:border-r-0 cursor-pointer",
    active: "bg-text_secondary text-paper",
    idle: "text-text hover:bg-primary/5",
  },
  panel_header: "flex items-center justify-between mb-2",
  panel_nav: "p-1 rounded-md text-text_secondary hover:bg-primary/10",
  panel_title: "text-base font-semibold text-text",
  week_grid: "grid grid-cols-7",
  week_head: "py-1.5 text-xs text-center text-text_secondary",
  week_day: "py-1.5 text-sm text-center tabular-nums text-text cursor-pointer disabled:cursor-default",
  weekend: "bg-text_secondary/5",
  month_grid: "grid grid-cols-3 gap-1",
  month_cell: "flex flex-col items-center rounded-md p-1 cursor-pointer disabled:cursor-default",
  month_name: "text-sm text-text mb-0.5",
  mini_grid: "grid grid-cols-7 gap-x-[3px] text-[8px] leading-[11px] text-center tabular-nums text-text_secondary",
  quarter_row: "grid grid-cols-4 items-center rounded-md py-2 text-sm text-center text-text cursor-pointer disabled:cursor-default",
  year_list: "max-h-72 overflow-y-auto flex flex-col",
  year_item: "py-2 text-sm text-center tabular-nums text-text rounded-md cursor-pointer",
  cell_muted: "opacity-40",
  cell_disabled: "opacity-30",
  cell_hover: "bg-primary/5",
  cell_hover_able: "hover:bg-primary/5",
  cell_selected: "bg-primary/10 text-primary font-semibold",
}

export const ADMIN_PERIOD = {
  stepper: "flex items-center gap-1",
  step_button: "shrink-0 p-1 rounded-md text-admin_primary hover:bg-admin_primary/10 disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-default",
  step_icon: "w-5 h-5",
  popup_wide: "w-[330px] max-w-[calc(100vw-32px)]",
  tabs: "flex mb-3 rounded-lg border border-admin_bordered overflow-hidden",
  tab: {
    base: "flex-1 px-1 py-1.5 text-sm text-center border-r border-admin_bordered last:border-r-0 cursor-pointer",
    active: "bg-admin_text_secondary text-admin_paper",
    idle: "text-admin_text hover:bg-admin_primary/5",
  },
  panel_header: "flex items-center justify-between mb-2",
  panel_nav: "p-1 rounded-md text-admin_text_secondary hover:bg-admin_primary/10",
  panel_title: "text-base font-semibold text-admin_text",
  week_grid: "grid grid-cols-7",
  week_head: "py-1.5 text-xs text-center text-admin_text_secondary",
  week_day: "py-1.5 text-sm text-center tabular-nums text-admin_text cursor-pointer disabled:cursor-default",
  weekend: "bg-admin_text_secondary/5",
  month_grid: "grid grid-cols-3 gap-1",
  month_cell: "flex flex-col items-center rounded-md p-1 cursor-pointer disabled:cursor-default",
  month_name: "text-sm text-admin_text mb-0.5",
  mini_grid: "grid grid-cols-7 gap-x-[3px] text-[8px] leading-[11px] text-center tabular-nums text-admin_text_secondary",
  quarter_row: "grid grid-cols-4 items-center rounded-md py-2 text-sm text-center text-admin_text cursor-pointer disabled:cursor-default",
  year_list: "max-h-72 overflow-y-auto flex flex-col",
  year_item: "py-2 text-sm text-center tabular-nums text-admin_text rounded-md cursor-pointer",
  cell_muted: "opacity-40",
  cell_disabled: "opacity-30",
  cell_hover: "bg-admin_primary/5",
  cell_hover_able: "hover:bg-admin_primary/5",
  cell_selected: "bg-admin_primary/10 text-admin_primary font-semibold",
}

export default {
  // Default variant
  //-------------------------------------------------------------------------
  default: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-text mb-1",
    dropdown_button:
      "h-[42px] bg-paper flex items-center justify-between cursor-pointer border border-bordered rounded-lg px-4 py-2 ",
    dropdown_icon: "w-5 h-5 text-text_secondary mr-2",
    chevron_icon: "w-5 h-5 text-text_secondary",
    dropdown_text: "text-text",
    popup:
      "absolute right-0 text-text bg-paper border border-bordered rounded-lg shadow-lg mt-1 p-2 w-64 z-50",
    popup_scroll: "max-h-72 overflow-y-auto",
    preset_item: {
      base: "cursor-pointer flex items-center justify-between rounded-md px-4 py-2",
      active: "bg-primary/10 text-primary",
      hover: "hover:bg-canvas",
    },
    preset_check_icon: "w-5 h-5",
    custom_section: "border-t border-bordered pt-3 mt-3",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    ...PERIOD,
  },

  admin: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-admin_text_secondary mb-0.5",
    dropdown_button:
      "h-10 bg-admin_paper flex items-center justify-between cursor-pointer border border-admin_bordered rounded-lg px-4 py-2",
    dropdown_icon: "w-5 h-5 text-admin_text_secondary mr-2",
    chevron_icon: "w-5 h-5 text-admin_text_secondary",
    dropdown_text: "text-admin_text",
    popup:
      "absolute right-0 text-admin_text bg-admin_paper border border-admin_bordered rounded-lg shadow-lg mt-1 p-2 w-full z-50",
    popup_scroll: "max-h-72 overflow-y-auto",
    preset_item: {
      base: "cursor-pointer flex items-center justify-between rounded-md px-4 py-2",
      active: "bg-admin_primary/10 text-admin_primary",
      hover: "hover:bg-admin_primary/5",
    },
    preset_check_icon: "w-5 h-5",
    custom_section: "border-t border-admin_bordered pt-3 mt-3",
    highlight: "ring-2 ring-admin_primary ring-opacity-50 border-admin_primary",
    ...ADMIN_PERIOD,
  },

  // Compact variant with smaller sizes
  //-------------------------------------------------------------------------
  compact: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-text mb-0.5 text-xs",
    dropdown_button:
      "px-3 py-1.5 bg-paper flex items-center justify-between cursor-pointer border border-bordered rounded-lg h-[36px] text-sm",
    dropdown_icon: "w-4 h-4 text-text_secondary mr-1.5",
    chevron_icon: "w-4 h-4 text-text_secondary",
    dropdown_text: "text-text",
    popup:
      "absolute z-50 bg-paper border border-bordered rounded-lg shadow-lg mt-1 p-1.5 w-56 right-0",
    popup_scroll: "max-h-64 overflow-y-auto",
    preset_item: {
      base: "flex items-center justify-between rounded-md text-sm cursor-pointer px-3 py-1.5",
      active: "bg-primary/10 text-primary",
      hover: "hover:bg-canvas",
    },
    preset_check_icon: "w-4 h-4",
    custom_section: "border-t border-bordered pt-2 mt-2",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    ...PERIOD,
  },

  admin_compact: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-admin_text mb-0.5 text-xs",
    dropdown_button:
      "h-[36px] flex items-center justify-between text-sm bg-admin_paper cursor-pointer border border-admin_bordered rounded-lg px-3 py-1.5",
    dropdown_icon: "w-4 h-4 text-admin_text_secondary mr-1.5",
    chevron_icon: "w-4 h-4 text-admin_text_secondary",
    dropdown_text: "text-admin_text",
    popup:
      "absolute right-0 w-56 bg-admin_paper border border-admin_bordered rounded-lg shadow-lg p-1.5 mt-1 z-50",
    popup_scroll: "max-h-64 overflow-y-auto",
    preset_item: {
      base: "flex items-center justify-between rounded-md text-sm cursor-pointer px-3 py-1.5",
      active: "bg-admin_primary/10 text-admin_primary",
      hover: "hover:bg-admin_canvas",
    },
    preset_check_icon: "w-4 h-4",
    custom_section: "border-t border-admin_bordered pt-2 mt-2",
    highlight: "ring-2 ring-admin_primary ring-opacity-50 border-admin_primary",
    ...ADMIN_PERIOD,
  },

  // Large variant with increased sizes
  //-------------------------------------------------------------------------
  large: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-text text-base mb-2",
    dropdown_button:
      "h-[50px] flex items-center justify-between text-lg bg-paper cursor-pointer border border-bordered rounded-lg px-5 py-3",
    dropdown_icon: "w-6 h-6 text-text_secondary mr-3",
    chevron_icon: "w-6 h-6 text-text_secondary",
    dropdown_text: "text-text",
    popup:
      "absolute right-0 w-72 bg-paper border border-bordered rounded-lg shadow-lg mt-1 p-3 z-50",
    popup_scroll: "max-h-80 overflow-y-auto",
    preset_item: {
      base: "cursor-pointer flex items-center justify-between rounded-md text-lg px-5 py-2.5",
      active: "bg-primary/10 text-primary",
      hover: "hover:bg-canvas",
    },
    preset_check_icon: "w-6 h-6",
    custom_section: "border-t border-bordered pt-3 mt-4",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    ...PERIOD,
  },

  admin_large: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-admin_text text-base mb-2",
    dropdown_button:
      "h-[50px] flex items-center justify-between text-lg bg-admin_paper border border-admin_bordered cursor-pointer rounded-lg px-5 py-3",
    dropdown_icon: "w-6 h-6 text-admin_neutral_3 mr-3",
    chevron_icon: "w-6 h-6 text-admin_neutral_3",
    dropdown_text: "text-admin_text",
    popup:
      "absolute right-0 w-72 bg-admin_paper border border-admin_bordered rounded-lg shadow-lg p-3 mt-1 z-50",
    popup_scroll: "max-h-80 overflow-y-auto",
    preset_item: {
      base: "flex items-center justify-between  text-lg rounded-md cursor-pointer px-5 py-2.5",
      active: "text-admin_primary bg-admin_primary/10",
      hover: "hover:bg-admin_canvas",
    },
    preset_check_icon: "w-6 h-6",
    custom_section: "border-t border-admin_bordered pt-3 mt-4",
    highlight: "ring-2 ring-admin_primary ring-opacity-50 border-admin_primary",
    ...ADMIN_PERIOD,
  },
}